import $ from "jquery";
import moment from "moment/moment";
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import init from '../AccessControl/Check';


const AllRejectedCompany = (props) => {

    const pageName = "All Requested Company";
    init(pageName);

    const navigate = useNavigate();


    const [companyList, setCompanyList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(0);

    const [reqParam, setReqParam] = useState({
        page: 1,
    });

    const [deleteModal, setEditModal] = useState({
        isShow: false,
        info: {}
    });


    const [apiData, setApiData] = useState({});

    const [searchName, setSearchName] = useState("");
    const filterByName = () => {
        if( searchName?.toString().length === 0 ) {
            alert("Please enter name.");
            return;
        }

        setReqParam({ ...reqParam, name:searchName, page: 1 });
    }

    useEffect(()=>{
        if(searchName?.toString().length === 0) {
            setReqParam({ ...reqParam, name: "", page: 1 });
            $("#filter_btn").hide();
            return;
        }

        $("#filter_btn").show();
    },[searchName]);


    // Company List
    useEffect(() => {
        PostLoginGetApi("rejected-company-all", reqParam, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setApiData(responseData["data"]);
                    setCompanyList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [isRefresh, reqParam]);


    
    // Restore Company 
    const handleForward = (obj) => {
        if(obj?.status === "edit") {
            return navigate("edit-req-company?id="+obj?.id, {
                state: {
                    data: {
                        // service_type: "voucher"
                    }
                }
            });
        }

        let reason = $("#forward_reason").val();
        if( reason.length === 0 ) {
            toast.error("Please write your remarks.");
            return;
        }

        // Call Request for forward requested company
        PostLoginPostApi("restore-company/"+obj?.id, JSON.stringify({reason: reason}), 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response['status'] === 1) {
                let responseData = JSON.stringify(response['data']);
                responseData = JSON.parse(responseData);

                if (responseData['code'] === 200) {
                    toast.success(responseData["messages"].toString());
                    setIsRefresh((prevCounter) => {
                        return prevCounter + 1;
                    });

                    setEditModal({
                        isShow: false,
                        info: {}
                    });
                    return;
                }
                toast.error(responseData["messages"].toString());
            }
        }).catch(err => {
            console.log(err);
        })
    }


    const block = () => {
        alert("Company registration link is not verified.");
        return;
    }


    

    return (

        <>
        {deleteModal?.isShow && (
            <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">

                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                    <h3 className="text-3xl font-semibold">
                        {deleteModal?.info?.company_name}
                    </h3>
                    <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => setEditModal({
                            isShow: false,
                            info: {}
                        })}
                    >
                        <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                        </span>
                    </button>
                    </div>
                    {/*body*/}

                    <div className="relative px-6 py-3 flex-auto">
                        <p className="my-4 text-blueGray-500 text-lg leading-relaxed">
                            Are you sure want to forward this registration request ?
                        </p>

                        <label htmlFor="forward_reason" className="block font-bold mb-1 text-sm text-gray-900 dark:text-white">Remarks</label>
                        <textarea id="forward_reason" rows="6" className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 resize-none" maxLength={300} placeholder="Please write your remarks"></textarea>
                    </div>

                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                    <button
                        className="py-2 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-semibold text-black focus:outline-none focus:ring-2  transition-all text-sm mr-3 border-black  hover:bg-black hover:text-white"
                        type="button"
                        onClick={() => setEditModal({
                            isShow: false,
                            info: {}
                        })}
                    >
                        Close
                    </button>
                    <button
                        className="py-2 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                        type="button"
                        onClick={() => handleForward({ status: "forward", id: deleteModal?.info?.id })}
                    >
                        Confirm
                    </button>
                    </div>
                </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
        )}

        <div className="custom-container w-full font-montserrat flex -mt-4">

            {/** Left Side */}

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-0 pt-3">
                    
                    
                    <div className="w-1/3 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5">Here’s your Rejected Request Companies at a glance</h6>
                    </div>


                    <div className="w-2/3 h-[68px] float-left text-right justify-end flex items-center">
                        <input type="search" id="search_by_name" name="search_by_name" value={searchName} onChange={(event)=>{setSearchName(event.currentTarget.value)}} placeholder="Search by company / poc name" className="rounded-md w-[400px] h-[45px] border-gray-500"/>
                        <button id="filter_btn" onClick={filterByName} type="button" className="hidden ml-2 bg-[#00D632] px-5 py-2 rounded-md text-white hover:opacity-75">Search</button>
                    </div>

                </div>

                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-5">
                        <div className='-m-1.5 pt-0'>
                            <div className='p-1.5 min-w-full inline-block align-middle'>
                                <div className="border rounded-lg shadow">
                                    <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                        <thead className='bg-neutral-100'>
                                            <tr className='text-left'>
                                                <th scope="col" className="px-4 text-center">#</th>
                                                <th scope="col" className="px-2 py-3 text-center">Logo</th>
                                                <th scope="col" className="pl-6 pr-2 py-3">Created On</th>
                                                <th scope="col" className="px-4 py-3">Created By</th>
                                                <th scope="col" className="pl-6 pr-2 py-3">Company Basic Info</th>
                                                <th scope="col" className="pl-6 pr-2 py-3">Phone & Address</th>
                                                <th scope="col" className="py-3 text-center">Service</th>
                                                <th scope="col" className="py-3 text-center w-[50]">Steps</th>
                                                {/* <th scope="col" className="px-2 py-3 text-center w-[220px]">Action</th> */}
                                            </tr>
                                        </thead>
                                        <tbody className='divide-y divide-gray-200'>
                                            {(companyList?.length === 0) &&
                                                <tr key="0">
                                                    <td className='px-6 py-1 text-center' colSpan={9}>
                                                        <p className='py-4'>No requested company available</p>
                                                    </td>
                                                </tr>
                                            }

                                            {companyList?.map((data, index) => {
                                                let step1, step2;
                                                let current_step = "Initialize";

                                                if( data.step1?.length > 0 ) {
                                                    // eslint-disable-next-line no-unused-vars
                                                    step1 = JSON.parse(data.step1);
                                                    current_step = <p><strong>1</strong> out of 4</p>;
                                                }

                                                if( data.step2?.length > 0 ) {
                                                    // eslint-disable-next-line no-unused-vars
                                                    step2 = JSON.parse(data.step2);
                                                    current_step = <p><strong>2</strong> out of 4</p>;
                                                }

                                                if( data.step3?.length > 0 ) {
                                                    current_step = <p><strong>3</strong> out of 4</p>;
                                                }

                                                if( data.step4?.length > 0 ) {
                                                    current_step = <p><strong>4</strong> out of 4</p>;
                                                }



                                                return <tr key={index}>
                                                    <td className='border-r-2 text-center' title={moment(data.created_at).format('LTS')}>
                                                        <strong className="text-sm">
                                                            {index+1}
                                                        </strong>
                                                    </td>
                                                    <td className='py-2 border-r-2 text-center'>
                                                        {(step2?.logo) && 
                                                            <img src={step2?.logo} title={data.company_name} alt={data.company_name} className='max-h-[50px] max-w-[100px] m-auto'></img>
                                                        }
                                                    </td>
                                                    <td className='pl-6 pr-2 py-4 border-r-2' title={moment(data.created_at).format('LTS')}>
                                                        <strong className="text-sm">{moment(data.created_at).format("ll")}</strong>
                                                        <br /> {step1?.business_category_name}
                                                    </td>
                                                    <td className='pl-4 py-4 border-r-2'>
                                                        {data.name}<br/>
                                                        {data.mobile_number}
                                                    </td>
                                                    <td className='pl-6 pr-2 py-4 border-r-2'>
                                                        {(current_step === "Initialize") ? 
                                                            <>
                                                                <Link onClick={block} className='cursor-pointer text-[#0774E9]'>
                                                                    {data.company_name}
                                                                </Link>
                                                                <br/>{data.email_address}
                                                            </>
                                                            : 
                                                            <Link to={`/dashboard/company/active-company?id=${data.id}`} className='cursor-pointer text-[#0774E9]'>
                                                                {data.company_name}
                                                            </Link>
                                                        }
                                                        <br/>
                                                        {step1?.company_email}
                                                    </td>
                                                    <td className='pl-6 py-4 border-r-2'>
                                                        {step1?.mobile_number}<br/>
                                                        {step2?.address}
                                                    </td>
                                                    <td className='py-4 border-r-2 text-center'>
                                                        {step2?.service_type?.replace(",",", ") ?? "-"}
                                                    </td>
                                                    <td className='py-4 border-r-2 text-center'>
                                                        {current_step}
                                                    </td>

                                                    {/* <td className='py-4 text-center'>
                                                        {(current_step !== "Initialize") &&
                                                        <button type="button" onClick={() => handleForward({ status: "edit", id: data?.id })}  className="py-2 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mr-3">
                                                            Edit
                                                        </button>
                                                        }
                                                        
                                                        <button type="button" onClick={() => setEditModal({ isShow: true, info: data })} className="py-2 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-green-500 text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">Forward</button>
                                                    </td> */}
                                                </tr>
                                            }
                                            )}

                                            
                                        </tbody>
                                    </table>

                                </div>

                        </div>
                    </div>
                </div>


            </div>


        
        </div>
        </>


    );
};

export default AllRejectedCompany;